import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {};

export const VideoLibraryReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.MAXIMIZE_LIBRARY_PAGE:
      return { ...state, ...payload };

    case ActionTypes.SET_EDITED_VIDEO_DATA:
      return { ...state, ...payload };

    case ActionTypes.SET_INSEASON_DATA:
      return { ...state, ...payload };

    case ActionTypes.SET_OFFSEASON_DATA:
      return { ...state, ...payload };

    case ActionTypes.SET_OTHERSEASON_DATA:
      return { ...state, ...payload };

    case ActionTypes.DELETE_OR_RENAME_VIDEO:
      const updatingState = JSON.parse(JSON.stringify(state));
      const indexOfSeason =
        updatingState.fetchedSeasonData.allSeasonData.findIndex(
          (data) => data.seasonName === payload.seasonName
        );
      switch (payload.seasonType) {
        case "in-season":
          let inSeason =
            updatingState.fetchedSeasonData?.allSeasonData[indexOfSeason]
              .inSeasonData;
          const uploadedVideosIndex = inSeason?.findIndex(
            (x) => x?.weekName === payload?.weekName
          );
          if (payload.isVideoRenamed) {
            inSeason[uploadedVideosIndex][payload?.eventType] = inSeason[
              uploadedVideosIndex
            ][payload.eventType]?.map((item) => {
              if (item.id === payload.videoId) {
                item.eventMediaCategory = payload?.newVideoName + ".mp4";
              }
              return item;
            });
          } else {
            let inSeasonVideoRemoved = inSeason[uploadedVideosIndex][
              payload.eventType
            ].filter((data) => {
              return !payload.videoId.includes(data.id);
            });
            inSeason[uploadedVideosIndex][payload.eventType] =
              inSeasonVideoRemoved;
          }
          updatingState.fetchedSeasonData.allSeasonData[
            indexOfSeason
          ].inSeasonData = inSeason;
          //updating highlight data
          if (payload.isVideoFromHighlight) {
            let updatedHighlight;
            let highlight =
              updatingState?.fetchedSeasonData.allSeasonData[indexOfSeason]
                .highlight;
            if (payload.isVideoRenamed) {
              updatedHighlight = highlight.map((item) => {
                if (item.id === payload.videoId) {
                  item.eventMediaCategory = payload.newVideoName + ".mp4";
                }
                return item;
              });
            } else {
              updatedHighlight = highlight.filter(
                (item) => !payload.videoId.includes(item.id)
              );
            }
            updatingState.fetchedSeasonData.allSeasonData[
              indexOfSeason
            ].highlight = updatedHighlight;
          }
          return { ...updatingState };

        case "off-season":
          let offSeason =
            updatingState.fetchedSeasonData.allSeasonData[indexOfSeason]
              .offSeasonData;
          const eventIndex = offSeason.findIndex(
            (x) => x.eventName === payload.offSeasonEventName
          );
          offSeason[eventIndex].arr.map((item) => {
            if (item.practiceName === payload.practiceName) {
              if (payload.isVideoRenamed) {
                item.practiceArray.map((data) => {
                  if (data.id === payload.videoId) {
                    data.eventMediaCategory = payload.newVideoName + ".mp4";
                  }
                });
              } else {
                const offSeasonVideoRemoved = item.practiceArray.filter(
                  (element) => {
                    return !payload.videoId.includes(element.id);
                  }
                );
                item.practiceArray = offSeasonVideoRemoved;
              }
            }
          });
          updatingState.fetchedSeasonData.allSeasonData[
            indexOfSeason
          ].offSeasonData = offSeason;
          //updating highlight data
          if (payload.isVideoFromHighlight) {
            let updatedHighlight;
            let highlight =
              updatingState.fetchedSeasonData.allSeasonData[indexOfSeason]
                .highlight;
            if (payload.isVideoRenamed) {
              updatedHighlight = highlight.map((item) => {
                if (item.id === payload.videoId) {
                  item.eventMediaCategory = payload.newVideoName + ".mp4";
                }
                return item;
              });
            } else {
              updatedHighlight = highlight.filter(
                (item) => !payload.videoId.includes(item.id)
              );
            }
            updatingState.fetchedSeasonData.allSeasonData[
              indexOfSeason
            ].highlight = updatedHighlight;
          }
          return { ...updatingState };

        case "other":
          let otherSeason =
            updatingState.fetchedSeasonData.allSeasonData[indexOfSeason]
              .otherSeasonData;

          const otherSeasonTypeIndex = otherSeason.findIndex(
            (x) => x.seasonType === payload.otherSeasonEventType
          );

          if (payload.isVideoRenamed) {
            otherSeason[otherSeasonTypeIndex].arrData.map((item) => {
              if (item.id === payload.videoId) {
                item.eventMediaCategory = payload.newVideoName + ".mp4";
              }
            });
          } else {
            const otherSeasonVideoRenamed = otherSeason[
              otherSeasonTypeIndex
            ].arrData.filter((data) => {
              return !payload.videoId.includes(data.id);
            });
            otherSeason[otherSeasonTypeIndex].arrData = otherSeasonVideoRenamed;
          }
          updatingState.fetchedSeasonData.allSeasonData[
            indexOfSeason
          ].otherSeasonData = otherSeason;
          //updating highlight data
          if (payload.isVideoFromHighlight) {
            let updatedHighlight;
            let highlight =
              updatingState.fetchedSeasonData.allSeasonData[indexOfSeason]
                .highlight;
            if (payload.isVideoRenamed) {
              updatedHighlight = highlight.map((item) => {
                if (item.id === payload.videoId) {
                  item.eventMediaCategory = payload.newVideoName + ".mp4";
                }
                return item;
              });
            } else {
              updatedHighlight = highlight.filter((item) => {
                return !payload.videoId.includes(item.id);
              });
            }
            updatingState.fetchedSeasonData.allSeasonData[
              indexOfSeason
            ].highlight = updatedHighlight;
          }

          return { ...updatingState };

        default:
          break;
      }

    case ActionTypes.FETCH_ALL_SEASON_DATA:
      return { ...state, fetchedSeasonData: payload };

    case ActionTypes.CHECK_UNCHECK_VIDEO:
      const updatingState2 = JSON.parse(JSON.stringify(state));
      const indexOfSeason2 =
        updatingState2.fetchedSeasonData.allSeasonData.findIndex(
          (data) => data.seasonName === payload.seasonName
        );

      switch (payload.seasonType) {
        case "In Season":
          let inSeason = updatingState2.fetchedSeasonData.allSeasonData[
            indexOfSeason2
          ].inSeasonData.map((ele) => {
            ele?.game?.map((el) => {
              if (payload.status) {
                if (el.id == payload.playlistID) {
                  el.checked = true;
                  return el;
                } else {
                  el.checked = false;
                  return el;
                }
              } else {
                el.checked = false;
                return el;
              }
            });

            ele?.practice?.map((el) => {
              if (payload.status) {
                if (el.id == payload.playlistID) {
                  el.checked = true;
                  return el;
                } else {
                  el.checked = false;
                  return el;
                }
              } else {
                el.checked = false;
                return el;
              }
            });

            ele?.opponentScout?.map((el) => {
              if (payload.status) {
                if (el.id == payload.playlistID) {
                  el.checked = true;
                  return el;
                } else {
                  el.checked = false;
                  return el;
                }
              } else {
                el.checked = false;
                return el;
              }
            });

            return ele;
          });

          updatingState2.fetchedSeasonData.allSeasonData[
            indexOfSeason2
          ].inSeasonData = inSeason;
          return { ...updatingState2 };

        case "Off Season":
          let offSeason = updatingState2.fetchedSeasonData.allSeasonData[
            indexOfSeason2
          ].offSeasonData.map((ele) => {
            ele?.arr?.map((el) => {
              el?.practiceArray?.map((el2) => {
                if (payload.status) {
                  if (el2.id == payload.playlistID) {
                    el2.checked = true;
                    return el2;
                  } else {
                    el2.checked = false;
                    return el2;
                  }
                } else {
                  el2.checked = false;
                  return el2;
                }
              });
            });

            return ele;
          });
          updatingState2.fetchedSeasonData.allSeasonData[
            indexOfSeason2
          ].offSeasonData = offSeason;
          return { ...updatingState2 };

        case "Other Season":
          let otherSeason = updatingState2.fetchedSeasonData.allSeasonData[
            indexOfSeason2
          ].otherSeasonData.map((ele) => {
            ele?.arrData?.map((el) => {
              if (payload.status) {
                if (el.id == payload.playlistID) {
                  el.checked = true;
                  return el;
                } else {
                  el.checked = false;
                  return el;
                }
              } else {
                el.checked = false;
                return el;
              }
            });

            return ele;
          });
          updatingState2.fetchedSeasonData.allSeasonData[
            indexOfSeason2
          ].otherSeasonData = otherSeason;
          return { ...updatingState2 };

        default:
          break;
      }

    case ActionTypes.DELETE_VIDEO_FROM_PAST_SEASON:
      return state;

    case ActionTypes.RESET_VIDEOLIBRARY_INITIAL_STATE:
      return initialState;

    case ActionTypes.VIDEO_LIBRARY_LOADING:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};
